import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import AIONImage from '../../images/angels/AION.png';
import BULWARKImage from '../../images/angels/BULWARK.png';
import LUMENImage from '../../images/angels/Lumen.png';
import GLITCHImage from '../../images/angels/GLITCH.png';
import RIFTWALKERImage from '../../images/angels/RIFTWALKER.png';
import EMBERSAINTImage from '../../images/angels/EMBER.png';
import WARDENZEROImage from '../../images/angels/WARDEN_O.png';
import IRONCLAUSEImage from '../../images/angels/IRONCLAUSE.png';
import PROBABILITYKIDImage from '../../images/angels/PROBABILITY_KID.png';
import SIRENZEROImage from '../../images/angels/SIREN_ZERO.png';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { angelsData } from '../../utils/angelsData';



const AngelsSlider = () => {
    const navigate = useNavigate();

    const handleAngelClick = (angelId) => {
        // Navigate to angel details page
        navigate(`/angel/${angelId}`);
    };

    return (
        <motion.div
            className="w-full py-4 "
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
        >
            <div className="max-w-full mx-auto px-4">
                {/* Section Title */}
                <motion.div
                    className="text-center mb-2"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ delay: 0.3, duration: 0.8 }}
                    viewport={{ once: true }}
                >
                    <h2 className="text-4xl pt-16 md:text-5xl font-bold pb-4 bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">
                        Meet the Angels
                    </h2>
                    <div className="w-32 h-1 bg-gradient-to-r from-red-600 to-orange-500 mx-auto mb-6"></div>
                    <p className="text-gray-400 text-lg max-w-2xl mx-auto">
                        Discover the extraordinary individuals shaping the fate of multiple realities
                    </p>
                </motion.div>

                {/* Swiper Slider */}
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={30}
                    slidesPerView={1}
                    // navigation
                    // pagination={{
                    //     clickable: true,
                    //     dynamicBullets: true
                    // }}
                    loop={true}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    breakpoints={{
                        640: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                        },
                        1024: {
                            slidesPerView: 5,
                            spaceBetween: 30,
                        },
                    }}
                    className="angelSwiper"
                >
                    {angelsData.map((angel, index) => (
                        <SwiperSlide key={angel.id}>
                            <motion.div
                                className="h-full cursor-pointer group"
                                whileHover={{ y: -10 }}
                                transition={{ type: "spring", stiffness: 300 }}
                                onClick={() => handleAngelClick(angel.slug)}
                            >
                                <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-gray-800 shadow-2xl h-full transition-all duration-300 group-hover:border-gray-600 group-hover:shadow-red-500/10">
                                    {/* Image Container */}
                                    <div className="relative h-64 overflow-hidden">
                                        <div className={`absolute inset-0  opacity-20`} />
                                        <img
                                            src={angel.image}
                                            alt={angel.name}
                                            className="w-full h-full object-fill transition-transform duration-500 group-hover:scale-110"
                                        />
                                        {/* <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-80" /> */}

                                        {/* Name Badge */}
                                        {/* <div className="absolute top-4 left-4">
                                            <span className="bg-black/80 backdrop-blur-sm text-white px-3 py-1 rounded-full text-sm font-bold border border-gray-700">
                                                {angel.name}
                                            </span>
                                        </div> */}
                                    </div>

                                    {/* Content */}
                                    <div className="p-6">
                                        <h3 className="text-xl font-bold text-white mb-2 group-hover:text-red-400 transition-colors duration-300">
                                            {angel.name}
                                        </h3>
                                        <p className="text-gray-300 leading-relaxed mb-4">
                                            {angel.description}
                                        </p>
                                    </div>
                                </div>
                            </motion.div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Custom Swiper Styles */}
                <style jsx>{`
                    .angelSwiper {
                        padding: 20px 10px 60px;
                    }
                    .angelSwiper :global(.swiper-button-next),
                    .angelSwiper :global(.swiper-button-prev) {
                        color: #ef4444;
                        background: rgba(0, 0, 0, 0.8);
                        width: 50px;
                        height: 50px;
                        border-radius: 50%;
                        border: 1px solid #374151;
                    }
                    .angelSwiper :global(.swiper-button-next:after),
                    .angelSwiper :global(.swiper-button-prev:after) {
                        font-size: 20px;
                    }
                    .angelSwiper :global(.swiper-pagination-bullet) {
                        background: #4b5563;
                        opacity: 0.7;
                    }
                    .angelSwiper :global(.swiper-pagination-bullet-active) {
                        background: #ef4444;
                        opacity: 1;
                    }
                `}</style>
            </div>
        </motion.div>
    );
};

export default AngelsSlider;